/** Shared look of text-like controls (Input, Select, PickerSheet, ScanField). */
export const controlBase =
  'w-full rounded-chip border bg-surface text-ink placeholder:text-muted/70 transition-colors focus-visible:border-amber focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-paper-sunk disabled:text-muted'

export function controlBorder(invalid: boolean): string {
  return invalid ? 'border-danger' : 'border-rule hover:border-ink/30'
}
